<ngx-guided-tour [backText]="PreviousbuttonContent" [nextText]="NextbuttonContent"
    [skipText]="SkipbuttonContent"></ngx-guided-tour>